export default "__VITE_ASSET__DUwQvBuy__"